import i18n from '@/i18n/index'
export function getNull (data) {
  return data === true ? i18n.t('text.yes') : data === false ? i18n.t('text.no') : data
}
